import { notify, NotifyAlignment } from "react-simple-notify";

import { StatusPopup } from "../components/status-popup";
import { MEDIA_QUERIES } from "../constants/media-queris";

interface ErrorPopupOptions {
  id?: string;
  title: string;
  text: string;
}

export const showErrorPopup = ({ id, title, text }: ErrorPopupOptions) => {
  notify.open({
    id,
    duration: 6_000,
    alignment: matchMedia(MEDIA_QUERIES.md).matches
      ? NotifyAlignment.bottomRight
      : NotifyAlignment.topRight,
    render: ({ onClose }) => (
      <StatusPopup icon="Error" title={title} text={text} onClose={onClose} />
    ),
  });
};

export const showCabinetAccessDeniedPopup = (message: string) =>
  showErrorPopup({
    id: "cabinet-access-denied",
    title: "Вход недоступен",
    text: message,
  });
